import axios from 'axios'
import { santipapHashing } from '../utils';
export const FETCH_SEARCHINPUT = 'fetch_searchinput'
export const FETCH_PRODUCTS = 'fetch_products'
export const FETCH_PRODUCT = 'fetch_product'
export const SET_INTERVAL = 'set_interval'
export const FETCH_CAROUSELS = 'fetch_carousel'
export const FETCH_SUGGEST_PRODUCTS = 'fetch_suggest_products'
export const FETCH_PROMOTION_PRODUCTS = 'fetch_promotion_products'
export const CREATE_ACCOUNT = 'create_account'
export const FETCH_EDIT_USER_INFO_FORM_INITIAL = 'fetch_edit_user_info_form_initial'
export const UPDATE_ACCOUNT = 'update_account'
export const USER_LOGIN = 'user_login'
export const FETCH_CART_PRODUCTS = 'fetch_cart_products'
export const FETCH_EXTRACART_PRODUCTS = 'fetch_extracart_products'
export const UPDATE_CART_PRODUCTS = 'update_cart_products'
export const UPDATE_EXTRACART_PRODUCTS = 'update_extracart_products'
export const UPDATE_GEO_ADDRESS = 'update_geo_address'
export const CHANGE_SEARCH_LABEL = 'change_search_label'
export const SET_LOADING_SEARCH_PAGE = 'set_loading_search_page'
export const SET_PRODUCTS_REDUCER = 'set_products_reducer'
export const CHECKOUT_OMISE = 'checkout_omise'
export const CREATE_ORDER = 'create_order'
export const GET_ORDERHISTORY = 'get_orderhistory'
export const REFRESH_ORDERHISTORY = 'refresh_orderhistory'
export const CHECK_CART_PRODUCTS_PRICE = 'check_cart_products_price'
export const SET_PAYMENT_STAGE = 'set_payment_stage'
export const SET_DELIVERY_TIME = 'set_delivery_time'
export const GET_DELIVERY_CHARGE = 'get_delivery_charge'
export const CLEAR_DELIVERY_CHARGE = 'clear_delivery_charge'
export const SHOW_BUTTON_USER_INFO_PAGE = 'show_button_user_info_page'
export const CREATE_CUSTOMER_OMISE = 'create_customer_omise'
export const GET_CREDIT_CARD_BY_PHONE_NUMBER = 'get_credit_card_by_phone_number'
export const CLEAR_CREDIT_CARD = 'clear_credit_card'
export const CHANGE_CARD_OMISE = 'change_card_omise'
export const CLEAR_CHECK_PRICE_RESPONSE = 'clear_check_price_response'
export const FETCH_EVENT_PRODUCTS = 'fetch_event_products'
export const FETCH_EVENT_PRODUCTS2 = 'fetch_event_products2'
export const TRIG_OVERLAY = 'trig_overlay'
export const CLEAR_OVERLAY = 'clear_overlay'
export const FETCH_PRODUCTS_FOR_RANDOM = 'fetch_products_for_random'
export const GET_BLOGS = 'get_blogs'
export const GET_BLOG_BY_ID = 'get_blog_by_id'
export const CHECK_PROMOCODE = 'check_promocode'
export const CLEAR_PROMOCODE = 'clear_promocode'
export const PASSWORD_CHANGE = 'password_change'
export const PHONE_NUMBER_CHECK = 'phone_number_check'
export const OTP_CHECK = 'otp_check'
export const CHANGE_PASSWORD_OTP = 'change_password_otp'


const ROOT_URL = 'https://us-central1-freshmate-a2518.cloudfunctions.net/v2'
//const ROOT_URL = 'http://localhost:5000/freshmate-a2518/us-central1/v2'
//  const ROOT_URL = 'http://localhost:5000/freshmate-a2518/us-central1/test'
// const ROOT_URL2 = 'http://songsod.com:3000'

//DEV
// const ROOT_URL2 = 'http://127.0.0.1:3000'
//const ROOT_URL2 = 'http://localhost:3000'
//PROD
const ROOT_URL2 =  'https://apiv2.songsod.com'

function getConfigHeader(key, value) {
    const headerkey = key
    const headervalue = value
    let headers = { headers: {} }
    headers['headers'][headerkey] = headervalue
    return headers
}

export function setInterval(value) {
    return {
        type: SET_INTERVAL,
        payload: value
    }
}

export function fetchSearchInput(value) {
    return {
        type: FETCH_SEARCHINPUT,
        payload: value
    }
}

export function fetchProduct(value) {
    let values = { keyword: value }
    const request = axios.post(`${ROOT_URL2}/getproduct`, values)
    return {
        type: FETCH_PRODUCT,
        payload: request
    }
}

export function fetchProducts(keyword, page, callback) {
    let realPage
    if (!page) {
        realPage = 1
    } else {
        realPage = page
    }
    let values = { keyword: keyword, page: realPage, number_of_element: 24 }
    const request = axios.post(`${ROOT_URL2}/search`, values)
    request.then(response => {
        if (response.status == 200 && callback) {
            callback(response.data.products)
        }
    })
    return {
        type: FETCH_PRODUCTS,
        payload: request
    }
}

export function fetchProductsForRandom() {
    let values = { keyword: 'categories' }
    const request = axios.post(`${ROOT_URL2}/search`, values)
    return {
        type: FETCH_PRODUCTS_FOR_RANDOM,
        payload: request
    }
}

export function fetchCarousels() {
    const request = axios.get(`${ROOT_URL2}/carousels`)
    return {
        type: FETCH_CAROUSELS,
        payload: request
    }
}

export function fetchSuggestProducts() {
    const request = axios.get(`${ROOT_URL2}/products_suggest`)
    return {
        type: FETCH_SUGGEST_PRODUCTS,
        payload: request
    }
}

export function fetchPromotionProducts() {
    const request = axios.get(`${ROOT_URL2}/products_promotions`)
    return {
        type: FETCH_PROMOTION_PRODUCTS,
        payload: request
    }
}

export function createAccount(values, callback, callbackerr) {
    const request = axios.post(`${ROOT_URL2}/create_account`, values)
        .then((response) => {
            if (response.status == 200) { callback() }
        })
        .catch((err) => {
            let errorMessage = err.message
            let statusCode = errorMessage.substring(errorMessage.length - 3, errorMessage.length)
            if (statusCode == '400') {
                callbackerr('มีเบอร์โทรศัพท์นี้ในระบบแล้วกรุณาตรวจสอบ หรือ ติดต่อเจ้าหน้าที่')
            }
            else {
                callbackerr(errorMessage)
            }
        })
    return {
        type: CREATE_ACCOUNT,
        payload: request
    }
}

export function fetchEditUserInfoFormInitial(values) {
    return {
        type: FETCH_EDIT_USER_INFO_FORM_INITIAL,
        payload: values
    }
}

export function updateAccount(values, token) {
    const header = getConfigHeader('Authorization', 'Bearer ' + token)
    const request = axios.post(`${ROOT_URL2}/update_account`, values, header)
        .catch(err => window.alert(err.errorMessage))
    return {
        type: UPDATE_ACCOUNT,
        payload: request
    }
}
///
//
///
///
export function userLogin(values, callbackerr) {
    const request = axios.post(`${ROOT_URL2}/user/login`, values)
        .catch(err => callbackerr())
    return {
        type: USER_LOGIN,
        payload: request
    }
}
//
//
export function fetchCartProducts() {
    let products = JSON.parse(localStorage.getItem('cart_products'))
    return {
        type: FETCH_CART_PRODUCTS,
        payload: products
    }
}

export function fetchExtraCartProducts() {
    let products = JSON.parse(localStorage.getItem('extracart_products'))
    return {
        type: FETCH_EXTRACART_PRODUCTS,
        payload: products
    }
}

export function updateCartProducts(products) {
    if (products != {}) {
        localStorage.setItem('cart_products', JSON.stringify(products))
    }
    return {
        type: UPDATE_CART_PRODUCTS,
        payload: products
    }
}

export function updateCartExtraProducts(products) {
    if (products != {}) {
        localStorage.setItem('extracart_products', JSON.stringify(products))
    }
    return {
        type: UPDATE_EXTRACART_PRODUCTS,
        payload: products
    }
}

export function UpdateGEOAddress(location) {
    return {
        type: UPDATE_GEO_ADDRESS,
        payload: location
    }
}

export function changeSearchLabel(value) {
    return {
        type: CHANGE_SEARCH_LABEL,
        payload: value
    }
}

export function setLoadingSearchPage(value) {
    return {
        type: SET_LOADING_SEARCH_PAGE,
        payload: value
    }
}

export function setProductsReducer() {
    return {
        type: SET_PRODUCTS_REDUCER,
        payload: 'unique_products'
    }
}

export function checkoutOmise(value, callback, callbackerr) {
    const header = getConfigHeader('Content-type', 'application/x-www-form-urlencoded')
    const request = axios.post(ROOT_URL2 + '/omise/payment/charge/token', value)
        .then(response => { if (response.status == 200) { callback() } })
        .catch(err => callbackerr(err))
    return {
        type: CHECKOUT_OMISE,
        payload: request
    }
}

export function createOrder(value, token, callback, callbackerr) {
    const header = getConfigHeader('Authorization', 'Bearer ' + token)
    const request = axios.post(`${ROOT_URL2}/create_order_cart`, value, header)
        .catch((err) => { callbackerr(err) })
        .then(response => { if (response.status == 200) { callback(response.data.data) } })
    return {
        type: CREATE_ORDER,
        payload: request
    }
}

export function getOrderHistory(values, token) {
    const header = getConfigHeader('Authorization', 'Bearer ' + token)
    const request = axios.post(`${ROOT_URL2}/user_orders`, values, header)
    return {
        type: GET_ORDERHISTORY,
        payload: request
    }
}

export function checkCartProductsPrice(values, token, callbackerr) {
    const header = getConfigHeader('Authorization', 'Bearer ' + token)
    const request = axios.post(`${ROOT_URL2}/check_cart_products_price`, values, header)
        .catch((err) => { console.log(err); callbackerr() })
    return {
        type: CHECK_CART_PRODUCTS_PRICE,
        payload: request
    }
}

export function setPaymentStage(payment_stage) {
    return {
        type: SET_PAYMENT_STAGE,
        payload: payment_stage
    }
}

export function setDeliveryTime(delivery_time, preorder) {
    return {
        type: SET_DELIVERY_TIME,
        payload: `${delivery_time}${preorder ? ';p' : ''}`
    }
}

export function getDeliveryCharge(values, preorder, drivethru) {
    const request = axios.post(`${ROOT_URL2}/get_delivery_fee`, values)
        .catch((err) => { console.log(err); window.alert(err) })
    return {
        type: GET_DELIVERY_CHARGE,
        payload: (drivethru || preorder || request)
    }
}

export function clearDeliveryCharge() {
    return {
        type: CLEAR_DELIVERY_CHARGE,
        payload: ''
    }
}

export function showButtonUserInfoPage(value) {
    return {
        type: SHOW_BUTTON_USER_INFO_PAGE,
        payload: value
    }
}

export function createCustomerOmise(values, callback, callbackerr) {
    const request = axios.post(ROOT_URL2 + '/omise/customer/create', values)
        .then((response) => { if (response.status == 200) { callback() } })
        .catch((err) => { callbackerr(err) })
    return {
        type: CREATE_CUSTOMER_OMISE,
        payload: request
    }
}

export function refreshOrderhistory() {
    return {
        type: REFRESH_ORDERHISTORY,
        payload: ''
    }
}
export function getCreditCardByPhoneNumber(phone_number, callback, callbackerr) {
    const request = axios.get(ROOT_URL2 + '/omise/customer/cards/' + phone_number)
        .catch(err => {
            if (err) {
                let payload_str = String(err)
                let statuscode = ((payload_str).substring((payload_str).length - 3, (payload_str).length))
                if (statuscode == '404') {
                    callback()
                } else {
                    callbackerr()
                }
            }
        })
    return {
        type: GET_CREDIT_CARD_BY_PHONE_NUMBER,
        payload: request
    }
}

export function clearCreditCard() {
    return {
        type: CLEAR_CREDIT_CARD,
        payload: {}
    }
}

export function changeCardOmise(values, callback, callbackerr) {
    const request = axios.post(ROOT_URL2 + '/omise/customer/change', values)
        .then((response) => { if (response.status == 200) { callback() } })
        .catch((err) => { callbackerr(err) })
    return {
        type: CHANGE_CARD_OMISE,
        payload: request
    }
}

export function clearCheckPriceResponse() {
    return {
        type: CLEAR_CHECK_PRICE_RESPONSE,
        payload: {}
    }
}

export function fetchEventProducts() {
    const request = axios.get(`${ROOT_URL2}/event_products`)
    return {
        type: FETCH_EVENT_PRODUCTS,
        payload: request
    }
}

export function fetchEventProducts2() {
    const request = axios.get(`${ROOT_URL2}/event_products2`)
    return {
        type: FETCH_EVENT_PRODUCTS2,
        payload: request
    }
}

export function trigOverlay(values) {
    return {
        type: TRIG_OVERLAY,
        payload: values
    }
}

export function clearOverlay() {
    return {
        type: CLEAR_OVERLAY,
        payload: '',
    }
}

export function getBlogs(callback, callbackerr) {
    const request = axios.get(ROOT_URL2 + '/blog/gets/active')
    return {
        type: GET_BLOGS,
        payload: request
    }
}

export function getBlogByID(blogID, callback, callbackerr) {
    const request = axios.get(ROOT_URL2 + '/blog/getView/' + blogID)
    request.then((response) => { if (response) { } })
        .catch((err) => { console.log(err) })
    return {
        type: GET_BLOG_BY_ID,
        payload: request
    }
}

export function checkPromoCode(promocode, money, token, callback, callbackInvalidPromoCode, callbackerr) {
    const header = getConfigHeader('Authorization', 'Bearer ' + token)
    const request = axios.post(`${ROOT_URL2}/check_promocode`, { promocode: promocode, money_received: money }, header)
    request.then(response => {
        callback(response.data.name)
    }).catch(error => {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            callbackInvalidPromoCode(error.response.data)
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log('Error Request', error.request);
            callbackerr()
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
            callbackerr()
        }
    })
    return {
        type: CHECK_PROMOCODE,
    }
}

export function changePassword(values, callback, callbackerr) {
    const request = axios.post(ROOT_URL2 + '/user/change_password', values)
    request.then((response) => { if (response.status == 200) { callback() } })
        .catch((err) => {
            if (err.response) {
                callbackerr(err.response.data)
            } else {
                callbackerr(500)
            }
        })
    return {
        type: PASSWORD_CHANGE,
        payload: request
    }
}

export function clearPromoCode() {
    return {
        type: CLEAR_PROMOCODE,
        payload: ''
    }
}

export function checkPhoneNumber(phoneNumber, callback, callbackerr) {
    const request = axios.get(ROOT_URL2 + '/otp/get/' + phoneNumber)
    request.then((response) => { if (response.status == 200) { callback() } })
        .catch((err) => {
            if (err.response) {
                callbackerr(err.response.data)
            } else {
                callbackerr(500)
            }
        })
    return {
        type: PHONE_NUMBER_CHECK,
        payload: request
    }
}

export function checkOTP(otp, phone_number, callback, callbackerr) {
    const request = axios.post(ROOT_URL2 + '/otp/verify', { otp: otp, phone_number: phone_number })
    request.then((response) => { if (response.status == 200) { callback() } })
        .catch((err) => {
            if (err.response) {
                callbackerr(err.response.data)
            } else {
                callbackerr(500)
            }
        })
    return {
        type: OTP_CHECK,
        payload: request
    }
}

export function changePasswordOTP(phone_number, new_password, callback, callbackerr) {
    const request = axios.post(ROOT_URL2 + '/user/forget_password', { phone_number, hash: santipapHashing(phone_number), new_password })
    request.then((response) => { if (response.status == 200) { callback() } })
        .catch((err) => {
            if (err.response) {
                callbackerr(err.response.data)
            } else {
                callbackerr(500)
            }
        })
    return {
        type: CHANGE_PASSWORD_OTP,
        payload: request
    }
}



// WEBPACK FOOTER //
// ./src/actions/index.js